module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet light"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt arrow-move",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "module-name"
  }, [_vm._v("GENERAL FORMS")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.getLoading) ? _c('vue-spinner') : _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1_1"
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-section",
    staticStyle: {
      "height": "350px",
      "overflow": "hidden"
    }
  }, [(_vm.workspace.general_forms && _vm.workspace.general_forms.length) ? _c('ul', {
    staticClass: "feeds"
  }, _vm._l((_vm.workspace.general_forms), function(record) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'General Forms Edit',
          params: {
            id: _vm.$route.params.id,
            dataid: record.id
          }
        },
        "tag": "a"
      }
    }, [_c('div', {
      staticClass: "col1"
    }, [_c('div', {
      staticClass: "cont"
    }, [_c('div', {
      staticClass: "cont-col2"
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(record.form_name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col2"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("formatDateModal")(record.created_date.date)))])])])], 1)
  }), 0) : _c('div', [_c('p', [_vm._v("No records available.")])])])])]), _vm._v(" "), _vm._v("\n     \n  ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-arrow-link pull-right"
  }, [_c('router-link', {
    staticClass: "text-warning",
    attrs: {
      "to": {
        name: 'General Forms',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "a"
    }
  }, [_vm._v("VIEW ALL | NEW")]), _vm._v(" "), _c('i', {
    staticClass: "icon-arrow-right"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "icon-globe font-dark hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark bold uppercase"
  }, [_vm._v("GENERAL FORMS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f28ed3d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GeneralForms.vue
// module id = 1755
// module chunks = 1